"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_ITEM_MOBILE = void 0;
const index_1 = require("../../generated-source/api/index");
exports.MOCK_CART_ITEM_MOBILE = {
    productDiscounts: [],
    productContent: {
        displayName: 'MEDIUM SIM PLAN',
    },
    sku: 'sim40monthly',
    cartItemId: '12467',
    additionalData: {
        productCategory: index_1.ProductCategory.Mobile,
        productQualification: {
            customerType: 'residential',
            fuelType: index_1.FuelTypes.DUAL,
            brand: '',
            offerId: '',
            siteAddress: {},
        },
        productConfiguration: {},
        productDisplayAttributes: {
            contractLengthUom: 'Months',
            contractType: 'Month to Month',
            productName: 'Mobile Plan Small',
            price: '40',
            infoDoc: '/content/dam/digital/agl/documents/agl-telecommunications-customer-terms.pdf',
            customerDoc: '/content/dam/digital/agl/documents/agl-telecommunications-customer-terms.pdf',
            dataAllowance: '30GB',
        },
    },
};
//# sourceMappingURL=cart-item-mobile.mock.js.map